:host{display:none}@media(max-width:768px){:host{display:flex}}
/*# sourceMappingURL=mobile-header-menu.component-DPB46RMC.css.map */
